/* global graphql  */
import PropTypes from 'prop-types'
import React from 'react'
import Helmet from 'react-helmet'
import Header from '../components/header-new'
import Footer from '../components/footer-new'
import HeroVideo from '../components/hero-video'
import ScrollingBanner from '../components/scrolling-banner'
import BrandPartnershipsPortfolio from '../components/brand-portfolio'
import CaseStudies from '../components/case-studies'

const BrandPartnershipsPage = ({ data }) => (
  <div className='wrapper--page-dark page--brand-partnerships'>
    <Helmet title='Brand Partnerships - ATTN:' />
    <Header theme='dark' />
    <div className='hero--fullbleed'>
      <HeroVideo
        desktopPosterSrc={data.drupalMedia.image_desktop.url}
        mobilePosterSrc={data.drupalMedia.image_mobile.url}
        desktopVideoSrc={data.drupalMedia.loop_desktop.file.url}
        mobileVideoSrc={data.drupalMedia.loop_mobile.file.url}
      />
    </div>
    <div className='brand-partnerships-intro'>
      <div className='brand-partnerships-intro__body'>
        We give brands an editorial "in" with our audience of socially conscious
        doers and deciders.
      </div>
    </div>
    <CaseStudies caseStudies={data.allDrupalProject.edges} />
    <ScrollingBanner background='green' text='Our work' length={10} />
    <BrandPartnershipsPortfolio portfolio={data.allDrupalPartner.edges} />
    <Footer />
  </div>
)

BrandPartnershipsPage.propTypes = {
  data: PropTypes.object
}

export default BrandPartnershipsPage

export const query = graphql`
  query BrandPartnershipsPage {
    drupalMedia(pid: {eq: "120"}) {
      image_desktop {
        url
      }
      image_mobile {
        url
      }
      loop_mobile {
        file {
          url
        }
      }
      loop_desktop {
        file {
          url
        }
      }
    }
    allDrupalPartner(sort: {fields: [weight], order: ASC}) {
      edges {
        node {
          id
          title
          image_mobile {
            url
          }
          image_desktop {
            url
          }
          loop_mobile {
            file {
              url
            }
          }
          loop_desktop {
            file {
              url
            }
          }
          video_desktop {
            file {
              url
            }
          }
          video_mobile {
            file {
              url
            }
          }
        }
      }
    }
    allDrupalProject(filter: {weight: {lt: 0}}, sort: {fields: [weight], order: DESC}) {
      edges {
        node {
          id
          eyebrow
          title
          description
          image_mobile {
            url
          }
          image_desktop {
            url
          }
          loop_mobile {
            file {
              url
            }
          }
          loop_desktop {
            file {
              url
            }
          }
          video_desktop {
            file {
              url
            }
          }
          video_mobile {
            file {
              url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/brandpartnerships.js